import { useState } from 'react';
import { DonViCoSo, KhachHang, TaiKhoan } from '@/types/schemas';

/**
 * Hook for managing search field selections in the search dialog
 * @returns Search field states and setters
 */
export const useSearchFieldState = () => {
  const [selectedTaiKhoanCo, setSelectedTaiKhoanCo] = useState<TaiKhoan | null>(null);
  const [selectedKhachHang, setSelectedKhachHang] = useState<KhachHang | null>(null);
  const [selectedTaiKhoanNo, setSelectedTaiKhoanNo] = useState<TaiKhoan | null>(null);
  const [selectedDonVi, setSelectedDonVi] = useState<DonViCoSo | null>(null);

  const resetSearchFields = () => {
    setSelectedTaiKhoanCo(null);
    setSelectedKhachHang(null);
    setSelectedTaiKhoanNo(null);
    setSelectedDonVi(null);
  };

  return {
    selectedTaiKhoanCo,
    selectedKhachHang,
    selectedTaiKhoanNo,
    selectedDonVi,

    setSelectedTaiKhoanCo,
    setSelectedKhachHang,
    setSelectedTaiKhoanNo,
    setSelectedDonVi,

    resetSearchFields
  };
};
